/**
 * Code 128-C баркод — БОДИТ, скан хийгдэнэ.
 *
 * Кодлолт нь `@boots/domain/barcode` дээр, 7 тесттэй. Энд зөвхөн
 * зурна.
 *
 * ⚠️ Тайван бүс (quiet zone) заавал: хоёр талд 10 модуль. Үүнгүй бол
 *    уншигч баркодны эхлэл/төгсгөлийг олохгүй.
 */

import { encodeCode128C, formatSerialDisplay } from '@boots/domain';

/** Стандарт шаардлага: дор хаяж 10 модуль (Code 128). */
const QUIET_ZONE = 10;

export function Barcode({
  serial,
  height = 40,
  showText = true,
  className = '',
}: {
  serial: string | null | undefined;
  height?: number;
  showText?: boolean;
  className?: string;
}) {
  if (!serial) return null;

  let encoded;
  try {
    encoded = encodeCode128C(serial);
  } catch {
    // Сондгой орон / цифр бус — зурахгүй, дугаарыг л харуулна
    return showText ? <span className="num text-[13px] text-ink-2">{serial}</span> : null;
  }

  const { bars, totalModules } = encoded;
  const width = totalModules + QUIET_ZONE * 2;

  return (
    <figure className={`flex flex-col items-center gap-1 ${className}`}>
      <svg
        viewBox={`0 0 ${width} 1`}
        preserveAspectRatio="none"
        style={{ height, width: '100%' }}
        shapeRendering="crispEdges"
        role="img"
        aria-label={`Баркод ${serial}`}
      >
        {bars.map((b) => (
          <rect key={b.x} x={b.x + QUIET_ZONE} y={0} width={b.width} height={1} fill="currentColor" />
        ))}
      </svg>
      {showText ? (
        <figcaption className="num text-[11.5px] tracking-[0.18em] text-ink-2">
          {formatSerialDisplay(serial)}
        </figcaption>
      ) : null}
    </figure>
  );
}
